import { getSirenFromSiret } from './getSirenFromSiret'

// The French TVA intracommunautaire is derived deterministically from the SIREN (the first
// 9 digits of the SIRET), so no network lookup is needed:
//   key = (12 + 3 * (SIREN mod 97)) mod 97
//   TVA = "FR" + zeroPad(key, 2) + SIREN
// e.g. SIREN 449831759 -> FR55449831759, SIREN 841714736 -> FR62841714736.
//
// Future enhancement (deferred per spec): validate the SIREN with the Luhn checksum before
// computing the key, to reject obviously malformed identifiers.
export const computeFrenchTva = (siret: string | undefined | null): string | null => {
  const siren = getSirenFromSiret(siret?.trim())

  if (!siren || !/^\d{9}$/.test(siren)) {
    return null
  }

  const key = (12 + 3 * (Number(siren) % 97)) % 97

  // Keep the SIREN as a string so any leading zeros survive.
  return `FR${String(key).padStart(2, '0')}${siren}`
}
